import { FC } from 'react'
import { Button, Flex, Table } from 'antd'
import PageLayout from '../../../components/page-layout/page-layout'
import { PlusOutlined } from '@ant-design/icons'
import Stamp from '../../../types/api/stamp'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'
import FiltersForm from './components/filters-form/filters-form'
import { useGetStampsQuery } from '../../../store/api/stamps-api'
import { Link } from 'react-router-dom'
import { routes } from '../../../constants/routes'
import qs from 'qs'
import FormValues from './components/filters-form/types/form-values'
import { columns } from './constants/columns'
import useTablePagination from '../../../hooks/table-pages/use-table-pagination'
import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../../hooks/table-pages/use-endpoint-query-parameters'

const deserializeFilters: DeserializeFilters = filtersString => {
    const filters = qs.parse(filtersString) as Partial<FormValues>

    return {
        number: { $contains: filters.number },
        roller: { documentId: { $eq: filters.roller } },
        shape: { $in: filters.shape },
        externalId: { $contains: filters.externalId },
        material_groups: { documentId: { $in: filters.materialGroups } },
    }
}

interface StampsPageProps {}

const StampsPage: FC<StampsPageProps> = () => {
    const params = useEndpointQueryParams({ deserializeFilters })
    const { data, isLoading } = useGetStampsQuery({ ...params, populate: '*' })
    const pagination = useTablePagination(params, data)
    const dataSource: Stamp[] = data?.data || []

    return (
        <PageLayout title={'Штампы'}>
            <Flex style={{ flex: '0 0 auto' }} justify={'end'}>
                <Link to={routes.equipmentStampNew}>
                    <Button type={'primary'} icon={<PlusOutlined />}>
                        Создать штамп
                    </Button>
                </Link>
            </Flex>

            <TableWrapper style={{ flex: 'auto' }}>
                <Table
                    bordered
                    columns={columns}
                    dataSource={dataSource}
                    pagination={pagination}
                    rowKey={record => record.number}
                    loading={isLoading}
                    summary={() => (
                        <Table.Summary fixed={'top'}>
                            <FiltersForm />
                        </Table.Summary>
                    )}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default StampsPage

/* <FormModal
                        title={'Редактирование штампа №' + record.number}
                        renderOpener={onOpen => (
                            <Button
                                size={'small'}
                                icon={<EditOutlined />}
                                title={'Редактировать'}
                                onClick={onOpen}
                            />
                        )}
                    >
                        <StampForm />
                    </FormModal> */

/* <FormModal
                        title={'Перезаказ штампа №' + record.number}
                        renderOpener={onOpen => (
                            <Button
                                size={'small'}
                                icon={<ReloadOutlined />}
                                title={'Перезаказать штамп'}
                                onClick={onOpen}
                            />
                        )}
                    >
                        <StampOrderForm />
                    </FormModal> */
